import React from 'react';
import { posthog } from 'posthog-js';
import { captureBrokenScreenShown } from '../utils';
import FeedbackModal from './feedback-modal';

interface IProps {
  children: React.ReactNode;
  fallback: React.ReactNode;
}

interface IState {
  hasError: boolean;
  showFeedbackModal: boolean;
}

class ErrorBoundaryCore extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { hasError: false, showFeedbackModal: false };
  }

  static getDerivedStateFromError(): IState {
    return { hasError: true, showFeedbackModal: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    posthog.captureException(error, {
      component_stack: errorInfo?.componentStack,
    });
    captureBrokenScreenShown({
      type: 'Exception',
      error_message: error?.message,
      component_stack: errorInfo?.componentStack,
    });
  }

  handleCloseFeedbackModal = () => {
    this.setState({ showFeedbackModal: false });
  };

  render() {
    const { hasError, showFeedbackModal } = this.state;
    const { children, fallback } = this.props;

    if (!hasError) {
      return children;
    }

    return (
      <>
        {fallback}
        <FeedbackModal
          show={showFeedbackModal}
          onClose={this.handleCloseFeedbackModal}
        />
      </>
    );
  }
}

export default ErrorBoundaryCore;
